<template>
    <div>
        <breadcrumbs
            :title="'Suorganizatori'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Suorganizator: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <suorganizator-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                ></suorganizator-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import SuorganizatorForma from "./SuorganizatorForma";
export default {
    name: "SuorganizatorDetails",
    components: {
        SuorganizatorForma,
        Breadcrumbs
    },
    data(){
        return {
            id: this.$route.params.suorganizator_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/suorganizatori',
                    name: 'Suorganizatori'
                },
                {
                    path: '/postavke/suorganizatori/' + this.id,
                    name: 'Suorganizator: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv || ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
